import React from "react";

export default function Menu() {
  return (
    <div
      className="settlementItem text"
      style={{
        marginTop: 10,
        height: 30,
        width: 450,
        borderRadius: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ flex: 1,paddingLeft:10 }} className="large">
        {" "}
        USER{" "}
      </div>
      <div style={{ flex: 1,display:"flex", justifyContent:"flex-end",alignItems:"center" }} className="large">
        {" "}
        P&L{" "}
      </div>
      <div style={{ flex: 1,display:"flex", justifyContent:"flex-end",alignItems:"center",paddingRight:10 }} className="large">
        {" "}
        BRK{" "}
      </div>
      <div style={{ flex: 1,display:"flex", justifyContent:"flex-end",alignItems:"center",paddingRight:10 }} className="large">
        {" "}
        TOTAL{" "}
      </div>
    </div>
  );
}
